let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2PJpv")).then(() => parcelRequire('9s0Bd'));